module.exports = __webpack_public_path__ + "media/crypto/avax-30dfa545.png";